// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","themeDev":"Footer_themeDev__22BE7","badge":"Footer_badge__1xzpo","themeDevText":"Footer_themeDevText__34moB"};